import IconUnchecked from '@mui/icons-material/Add';
import IconChecked from '@mui/icons-material/Check';
import { Box, Typography, useTheme } from '@mui/material';
import IconButton from '@mui/material/IconButton';

interface FormulaFieldSwitchProps {
  checked?: boolean;
  label: string;
  onChange: (checked: boolean) => void;
}

const FormulaFieldSwitch = ({
  checked,
  label,
  onChange,
}: FormulaFieldSwitchProps) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={theme.spacing(0.5)}
      sx={{
        [theme.breakpoints.down('md')]: { minWidth: theme.spacing(7.5) },
        color: checked ? theme.palette.grey[50] : theme.palette.grey[400],
        '&:hover': {
          color: theme.palette.grey[50],
        },
      }}
    >
      {checked ? (
        <IconButton
          onClick={() => onChange(false)}
          sx={{
            border: '1px solid',
            borderColor: theme.palette.grey[50],
            background: theme.palette.grey[50],
            color: theme.palette.grey[900],
            '&:hover': {
              background: theme.palette.grey[50],
            },
          }}
        >
          <IconChecked
            sx={{
              color: 'inherit',
            }}
          />
        </IconButton>
      ) : (
        <IconButton
          onClick={() => onChange(true)}
          sx={{
            border: '1px dashed',
            color: 'inherit',
            '&:hover': {
              background: 'transparent',
            },
          }}
        >
          <IconUnchecked />
        </IconButton>
      )}
      <Typography
        component="span"
        textAlign="center"
        fontSize={theme.spacing(1.375)}
        lineHeight={theme.spacing(2)}
        fontWeight={500}
        letterSpacing={0}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default FormulaFieldSwitch;
